import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { useCompaniesContext } from 'company/context'
import { PerformanceReportScreenProps } from 'home/stack/types'
import React, { useCallback } from 'react'
import { Linking, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { PerformanceReportView } from './views'

export function PerformanceReportScreen({
  navigation,
  route,
}: PerformanceReportScreenProps) {
  const { activeCompany, companies, setActiveCompanyId } = useCompaniesContext()
  const styles = useStyles()

  const onPressReportUrl = useCallback(async (url: string) => {
    await Linking.openURL(url)
  }, [])

  const onCompanySelected = useCallback(
    (id: string) => {
      setActiveCompanyId?.(id)
    },
    [setActiveCompanyId]
  )

  if (!companies || !activeCompany) {
    return (
      <View style={styles.container}>
        <Text>{t('noCompanySelected')}</Text>
      </View>
    )
  }

  return (
    <SafeAreaView
      edges={['left', 'right', 'bottom']}
      style={styles.safeAreaViewContainer}
    >
      <PerformanceReportView
        companies={companies}
        activeCompanyId={activeCompany.id}
        onCompanySelected={onCompanySelected}
        onPressReportUrl={onPressReportUrl}
      />
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  safeAreaViewContainer: {
    flex: 1,
  },
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
